export default __webpack_public_path__ + "static/Group-1258-2e429f936254d886af4f987c24dcffbb.png";